var _defs, _defs2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWave7(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "rotate(0deg)",
      transition: ".3s"
    },
    viewBox: "0 0 1440 310",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgba(255, 255, 255, 0.3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(255, 255, 255, 0.3)"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m0 248 21.8-20.7C43.6 207 87 165 131 165.3c43.5-.3 87 41.7 131 51.7 43.5 10 87-10 131-46.5C436.4 134 480 83 524 82.7c43.3.3 87 51.3 131 56.8 43.2 5.5 87-36.5 130-20.7C829.1 134 873 207 916 217c44 10 88-41 131-56.8 43.9-15.2 88 4.8 131 10.3 43.8 5.5 87-5.5 131-5.2 43.7-.3 87 10.7 131-15.5 43.6-25.8 87-87.8 131-108.5 43.5-20.3 87-.3 131 20.7 43.5 21 87 41 131 77.5 43.4 36.5 87 87.5 131 103.3 43.3 15.2 87-4.8 131-31 43.2-25.8 87-56.8 130-72.3 44.1-15.5 88-15.5 131 10.3 44 26.2 88 77.2 131 56.9 43.9-20.7 88-113.7 131-160.2 43.8-46.5 87-46.5 131 0 43.7 46.5 87 139.5 131 180.8 43.6 41.7 87 30.7 131 15.5 43.5-15.8 87-35.8 109-46.5l21.8-10.3v124H0Z",
    style: {
      transform: "translate(0,0)",
      opacity: 1
    }
  }), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgba(255, 255, 255, 0.3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(255, 255, 255, 0.3)"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m0 217 21.8-10.3C43.6 196 87 176 131 170.5c43.5-5.5 87 5.5 131-15.5 43.5-21 87-72 131-62 43.4 10 87 83 131 98.2 43.3 15.8 87-26.2 131-25.9 43.2-.3 87 41.7 130 25.9 44.1-15.2 88-88.2 131-124 44-36.2 88-36.2 131-20.7 43.9 15.5 88 46.5 131 82.7 43.8 35.8 87 77.8 131 103.3 43.7 25.5 87 36.5 131 41.3 43.6 5.2 87 5.2 131-15.5 43.5-20.3 87-62.3 131-82.6 43.5-20.7 87-20.7 131-15.5 43.4 4.8 87 15.8 131 10.3 43.3-5.5 87-25.5 131-25.8 43.2.3 87 20.3 130 10.3 44.1-10 88-52 131-62 44-10 88 10 131 15.5 43.9 5.5 88-5.5 131 0 43.8 5.5 87 25.5 131 41.3 43.7 15.2 87 26.2 131 25.9 43.6.3 87-10.7 131-31 43.5-20.7 87-51.7 109-67.2l21.8-15.5v248H0Z",
    style: {
      transform: "translate(0,50px)",
      opacity: 0.9
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave7);
export default __webpack_public_path__ + "static/media/wave(7).d9e8e7cb0803ce2555a2e1f03a9f7bb9.svg";
export { ForwardRef as ReactComponent };